import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/execute-time.actions';
import { Col, Row, Form, Modal, Input, DatePicker, TimePicker } from 'antd';
import {ReactComponent as SetExecuteTimeIcon } from '../resource/forms/ListTime.svg';
import moment from 'moment';

const { TextArea } = Input;

const ExecuteTimeForm = Form.create()(
	class extends React.Component {

		handleTimeStartChange = (val) => {
			const e = this.props.form.getFieldValue('executeTimeEnd')
			if(!e.isAfter(val)) {
				const ne = moment(val)
				if(ne.hour() == 23 && ne.minute() == 45) {
					this.props.form.setFieldsValue({ executeTimeEnd:  ne.set({'hour':0, 'minute': 0}) } )
				}
				else {
					this.props.form.setFieldsValue({ executeTimeEnd: ne.add(15,'m')} )
				}
			}
			//this.props.dispatch(actions.applyService(value));
		}

		handleTimeEndChange = (val) => {
			const s = this.props.form.getFieldValue('executeTimeStart')
			if(!s.isBefore(val)) {
				const ns = moment(val)
				if(!(ns.hour() == 0 && ns.minute() == 0)) {
					this.props.form.setFieldsValue({ executeTimeStart: ns.subtract(15,'m')} )
				}
			}
			//this.props.dispatch(actions.applyService(value));
		}

		render() {
			const { visible, onCancel, onCreate, form, fprops, confirmLoading } = this.props;
			const { getFieldDecorator } = form;
			const { request, newStatus, newStatusDescription, requestData } = fprops;

			return (
				<Modal className='dspx-icon-header'
					width={400}
					visible={visible}
					title={ newStatus 
						? <span><SetExecuteTimeIcon style={{ height: 40, verticalAlign:'middle', marginRight: 10 }}/> Изменение статуса заявки </span> 
						: <span><SetExecuteTimeIcon style={{ height: 40, verticalAlign:'middle', marginRight: 10 }}/> Установить дату назначения</span> }
					confirmLoading={confirmLoading}
					onCancel={onCancel}
					onOk={onCreate} >						
					<Form layout="vertical">

					{newStatus && <Row gutter={16}>
							<Col span={24} style={{paddingBottom:10}}>							
								Заявка: <strong>{request}</strong><br />
								Новый статус: <strong>{newStatusDescription}</strong>								
								<h4 style={{marginTop:10, color:'#26a69a'}}>Требуется указать новую дату назначения и причину переноса:</h4>								
							</Col>
					</Row>}
					{getFieldDecorator('request', { initialValue: fprops.request })(
							<Input type='hidden' />)}
					{getFieldDecorator('statusId', { initialValue:+newStatus})(
							<Input type='hidden' />)}
					{getFieldDecorator('statusDescr', { initialValue:newStatusDescription })(
							<Input type='hidden' />)}

						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="Дата и время назначения" >
									<Input.Group compact>
										{getFieldDecorator('executeDate', {
											initialValue: requestData?.executeDateTime ? moment(requestData.executeDateTime) : moment(),
											rules: [{ required: true, message: 'Пожалуйста укажите дату назначения' }]
										})(
											<DatePicker
												allowClear={false}
												format="DD.MM.YYYY" />
										)}
										{getFieldDecorator('executeTime', { 
											initialValue: requestData?.executeDateTime 
												? moment(moment(requestData.executeDateTime).format('HH:mm'), 'HH:mm') 
												: moment('18:00', 'HH:mm'), 
											rules: [{ required: true, message: 'Пожалуйста укажите время назначения' }]
										})(
											<TimePicker 
												allowClear={false}
												minuteStep={15}
												format="HH:mm" />
										)}
									</Input.Group>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="Причина переноса даты назначения">
									{getFieldDecorator('comment', {
										initialValue: '',
										rules: [{ required: true, whitespace: true, message: 'Пожалуйста укажите причину переноса даты назначения' }]
									})(
										<TextArea autoSize={{ minRows: 1, maxRows: 3 }} />)}
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
			);
		}
	});

class ExecuteTimeContainer extends Component {
	state = {
		confirmLoading: false,
	};

	handleCancel = () => {
		this.formRef.props.form.resetFields();
		this.props.dispatch(actions.closeExecuteTimeModal());
	}

	handleCreate = () => {
		const form = this.formRef.props.form;

		form.validateFields(async (err, values) => {

			if (err) return;

			form.resetFields();

			if(values.statusId == 8) {			
				// Покос травы	
				this.props.dispatch(actions.setHoldStatus(values));
			}
			else if(!values.statusId) {
				if (typeof this.props.updateExecuteTime === 'function') {
					this.setState({
						confirmLoading: true,
					});

					await this.props.updateExecuteTime(values);

					this.setState({
						confirmLoading: false,
					});
				} else {
					this.props.dispatch(actions.postExecuteTime(values));
				}
			}

			form.resetFields();
			this.props.dispatch(actions.closeExecuteTimeModal());
		});
	}

	saveFormRef = (formRef) => {

		this.formRef = formRef;
	}

	render() {

		return (
			<ExecuteTimeForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.executeTimeModalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
				confirmLoading={this.state.confirmLoading}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { executeTimeStore } = state;
	return executeTimeStore;
}

export default connect(mapStateToProps)(ExecuteTimeContainer);
